import { createFileRoute, redirect } from '@tanstack/react-router';
import { SelectTenantPage } from '@/features/auth/pages/select-tenant-page';
import { isApiError } from '@/lib/api';
import { requireVerifiedEmail } from '@/lib/email-gate';
import { safeRedirect, signInSearch } from '@/lib/home';
import { impersonationEndedRedirect } from '@/lib/impersonation-guard';
import { meQueryOptions } from '@/lib/me';

export const Route = createFileRoute('/select-tenant')({
  validateSearch: (s: Record<string, unknown>): { redirect?: string } => ({
    redirect: safeRedirect(s.redirect),
  }),
  beforeLoad: async ({ context, location }) => {
    const me = await context.queryClient.ensureQueryData(meQueryOptions).catch((e: unknown) => {
      if (isApiError(e) && e.status === 401) {
        const ended = impersonationEndedRedirect(e);
        if (ended) throw ended;
        throw redirect({ to: '/sign-in', search: signInSearch(location.href) });
      }
      throw e;
    });
    // signed in without a shop and without a confirmed email: the verify-email screen comes first
    requireVerifiedEmail(me);
  },
  component: SelectTenantPage,
});
